export default __webpack_public_path__ + "static/tile-variant-do-bb89eaa0c0a343f2a25f4b754c4cd09e.png";